export function useRouteViewTracker(routeName: string) {
  switch (routeName) {
    case 'deal-navigator-close-deals':
      return 'close_deals';
    case 'deal-navigator-generate-pipeline':
    case 'generate-pipeline':
      return 'gen_pipe';
    case 'edit_report':
      return 'reports';
    case 'ecosystem_insights':
      return 'performance';
    default:
      return routeName;
  }
}
